import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ControlChartCollectionsManagementView } from "src/components/views/spc/controlChartCollections/ControlChartCollectionsManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/controlChartCollections/management")({
	staticData: { title: i18n.t("control_chart_collections"), legacyViewKey: "controlChartCollectionsManagementView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ControlChartCollectionsManagementView />;
}
